import { createContext, useContext, useReducer } from 'react';

const CourseContext = createContext(null);
const CourseDispatchContext = createContext(null);

export function CourseProvider({ children, initialCourse }) {
    const [course, dispatch] = useReducer(courseChangeReducer, initialCourse);
    return (
        <CourseContext.Provider value={course}>
            <CourseDispatchContext.Provider value={dispatch}>
                {children}
            </CourseDispatchContext.Provider>
        </CourseContext.Provider>
    );
}

export function useCourse() {
    return useContext(CourseContext);
}

export function useCourseDispatch() {
    return useContext(CourseDispatchContext);
}

function courseChangeReducer(course, action) {
    const newCourse = JSON.parse(JSON.stringify(course));
    switch(action.type) {
        case "UPDATE_COURSE_INFO": {
            newCourse[action.propName] = action.propVal;
            return newCourse;
        }
        case "UPDATE_SG_INFO": {
            newCourse[action.propName] = action.propVal;
            if (newCourse.sgPlay === "sgNotAllowed") {
                newCourse.sgMembership = false;
                newCourse.sgRoundDiscount = false;
                newCourse.sgStandingTeeTimes = false;
                newCourse.sgFriendlinessRating = 0;
            }
            return newCourse;
        }
        case "UPDATE_HOLE_INFO": {
            newCourse.tees[action.tee].holes[action.holeNum-1][action.propName] = action.propVal;
            return newCourse;
        }
        case "UPDATE_TEE_NAME": {
            newCourse.tees[action.newTeeName] = newCourse.tees[action.prevTeeName];
            newCourse.tees[action.newTeeName].name = action.newTeeName;
            delete newCourse.tees[action.prevTeeName];
            return newCourse;
        }
        case "ADD_TEE": {
            newCourse.tees[action.teeName] = { name: action.teeName, holes: [] };
            return newCourse;
        }
        case "UPDATE_SLOPE_RATING_INFO": {
            newCourse.tees[action.tee][action.propName] = action.propVal;
            return newCourse;
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}
